<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'App',
    
  };
</script>

<style>
  @import './assets/css/style.css';
</style>
